import type { FundFeatureConfig } from '../../../types/insurances/FundFeatureConfig';

export const fund: FundFeatureConfig = {
    overview: {
        details: {
            showVariant: true,
        },
    },
    funds: {
        visible: false,
    },
};
